import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as selectors from '../../store/selectors';
import { getContacts, deleteContact } from '../../store/contacts.actions';
import baseStyles from '../styles';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Icon,
  Typography,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import ContactsList from './ContactsList';
import ContactCreateDialog from './ContactCreateDialog';

// FIXME checkout https://mui.com/components/use-media-query/#using-material-uis-breakpoint-helpers
const withMobileDialog = () => WrappedComponent => props => (
  <WrappedComponent {...props} width="lg" fullScreen={false} />
);

class ContactsListDialog extends Component {
  state = {
    isContactCreateDialogOpen: false,
    selectedContact: null,
  };

  componentDidMount() {
    const { getContacts } = this.props;
    getContacts();
  }

  handleAddClick = () => {
    const { onConfirm } = this.props;
    const { selectedContact } = this.state;
    onConfirm?.(selectedContact);
  };

  handleCancelClick = () => {
    const { onCancel } = this.props;
    onCancel?.();
  };

  handleContactSelect = contact => {
    this.setState(state => ({
      selectedContact:
        !state.selectedContact || state.selectedContact._id !== contact._id
          ? contact
          : null,
    }));
  };

  handleContactDelete = contact => {
    const { deleteContact } = this.props;
    deleteContact(contact._id);
  };

  handleCreateContactClick = () => {
    this.toggleContactCreateDialog();
  };

  handleCreateContactConfirm = () => {
    this.toggleContactCreateDialog();
  };

  toggleContactCreateDialog = () => {
    this.setState(state => ({
      isContactCreateDialogOpen: !state.isContactCreateDialogOpen,
    }));
  };

  render() {
    const { fullScreen, contacts, open, classes, t } = this.props;
    const { isContactCreateDialogOpen, selectedContact } = this.state;
    return (
      <Dialog open={open} fullScreen={fullScreen} fullWidth maxWidth="xs">
        <DialogTitle className={classes.dialogTitle}>
          <Typography variant="h6">{t('Contacts')}</Typography>
          <IconButton size="small" onClick={this.handleCreateContactClick}>
            <Icon>add</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.noPadding}>
          <ContactsList
            contacts={contacts}
            disableCall
            withSearch
            selectedContact={selectedContact}
            onContactSelect={this.handleContactSelect}
            onContactDelete={this.handleContactDelete}
          />
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={this.handleCancelClick}>
            {t('Cancel')}
          </Button>
          <Button
            color="primary"
            onClick={this.handleAddClick}
            disabled={!selectedContact}
          >
            {t('ADD')}
          </Button>
        </DialogActions>
        {isContactCreateDialogOpen && (
          <ContactCreateDialog
            open={isContactCreateDialogOpen}
            onCancel={this.handleCreateContactClick}
            onConfirm={this.handleCreateContactConfirm}
          />
        )}
      </Dialog>
    );
  }
}

const styles = theme => ({
  ...baseStyles(theme),
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const mapDispatchToProps = {
  getContacts,
  deleteContact,
};

const mapStateToProps = state => ({
  contacts: selectors.getSortedContacts(state),
});

export default withTranslation()(
  withStyles(styles)(
  withMobileDialog()(
    connect(mapStateToProps, mapDispatchToProps)(ContactsListDialog)
    )
  )
);
